import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

const RequireCharacter = () => {
  const { user, loading } = useContext(UserContext);
  
  // If still loading user data, render a loading state or nothing
  if (loading) {
    return <div className="loading-container">Checking character status...</div>;
  }
  
  // Check if user is logged in but doesn't have a playerCharacter or character is dead
  if (user) {
    const noCharacter = !user.playerCharacter;
    const characterDead = user.playerCharacter?.dead === true;
    
    if (noCharacter || characterDead) {
      return <Navigate to="/character/create" replace />;
    }
  } else if (user === null) {
    // If user is not logged in, redirect to login
    return <Navigate to="/" replace />;
  }
  
  // If user has a living character, render the protected route
  return <Outlet />;
};

export default RequireCharacter;
